import { Types } from '../../../constants';
import { WrapHelper } from '../WrapHelper';
export class WrapSymbolHelper extends WrapHelper {
    constructor() {
        super(...arguments);
        this.type = Types.Symbol;
    }
}

//# sourceMappingURL=WrapSymbolHelper.js.map
